import {
  BodyText,
  DialogContent,
  ModalFooter,
  ModalHeader,
  NextDialog,
} from '@cint/wonderment';

interface Props {
  open: boolean;
  fileName?: string;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteFileDialog = ({
  open,
  fileName,
  onClose,
  onDelete,
}: Props) => {
  return (
    <NextDialog open={open}>
      <DialogContent style={{ wordBreak: 'break-word' }}>
        <ModalHeader
          title={`You're about to remove ${fileName || 'this file'}`}
          isDismissible={false}
        />

        <BodyText>
          This action can&apos;t be undone. Are you sure you want to continue?
        </BodyText>
        <ModalFooter
          secondaryButtonProps={{ onClick: onClose, text: 'Cancel' }}
          primaryButtonProps={{ onClick: onDelete, text: 'Remove file' }}
          isDanger
        />
      </DialogContent>
    </NextDialog>
  );
};
